import { useContext,useState,useEffect}from "react";
import axios from "axios";
//import components
import Header from "./components/header/Header";
import Content from "./components/Content/Content";
import About from "./pages/about";
import ConectUs from "./pages/conectUs";
import Detail from "./components/Detail";
import Footer from "./components/footer/Footer";
import Login from "./pages/Login";
import Register from "./pages/Register";
import MainContainer from "./pages/Accant/MainContainer";
import Modal from './components/UI/Modal'
import ShopCart from './pages/ShopCart'

//import router
import { BrowserRouter, Routes, Route } from "react-router-dom";
//import material ui
import { Container } from "@material-ui/core";
//import CartContext
import CartContextProvider from "./context/CartContextProvider";

import CourcesContextProvider from "./context/CourcesContextProvider";
import {AuthContext} from "./context/AuthContextProvider"
import AuthContextProvider from "./context/AuthContextProvider";
//import toastyfy
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";


function App() {
  const [cources,setCources]= useState([]);
  useEffect(() => {
    const getData = async () => {
      const response = await axios.get(
        "https://academy-nyctophile.herokuapp.com/api/term/getall"
      );
      setCources(response.data.result);
    };
    getData();
  }, []);
  return (
    <div className="App">
      <Container>
        <BrowserRouter>
          <CartContextProvider>
            <CourcesContextProvider>
              <AuthContextProvider>
              {cources.length===0 && <Modal/>}
               <Header />
                
                <Routes>
                  <Route path="/cources/:_id" element={<Detail />} />
                  <Route path="/" element={<Content />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/conectUs" element={<ConectUs />} />
                 
                  <Route path="/Login" element={<Login />} />
                  <Route path="/SignUp" element={<Register />} />
                  <Route path="/cart" element={<ShopCart />} />
                  
                 <Route path="/accant/*" element={<MainContainer />}  />
                </Routes>
                <Footer />
              </AuthContextProvider>
            </CourcesContextProvider>
          </CartContextProvider>
        </BrowserRouter>
      </Container>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
